module.exports = __webpack_public_path__ + "static/media/testkit1.3ed4e27d.jpg";